import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../config/authConfig";
import corporateLogo from "../../assets/ltw.png";

/**
 * Pantalla de ingreso. Un unico boton "Ingresar" que dispara el login por
 * redireccion contra el tenant corporativo configurado en `msalConfig`.
 */
export default function LoginScreen() {
  const { instance } = useMsal();
  const [isRedirecting, setIsRedirecting] = useState<boolean>(false);

  const handleLogin = async (): Promise<void> => {
    setIsRedirecting(true);

    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error("ERROR AL INICIAR SESION", error);
      setIsRedirecting(false);
    }
  };

  return (
    <div className="login">
      <div className="login__card">
        <img className="login__logo" src={corporateLogo} alt="Teamwork" />

        <h1 className="login__title">Mensajería Confirmación de Beneficio</h1>
        <p className="login__text">
          Carga nóminas, envía la encuesta por WhatsApp y haz seguimiento de las
          respuestas.
        </p>

        <button
          type="button"
          className="btn btn--primary btn--lg btn--block"
          onClick={handleLogin}
          disabled={isRedirecting}
        >
          {isRedirecting && <span className="btn__spin" />}
          Ingresar
        </button>

        <div className="login__divider">Acceso corporativo</div>

        <p className="login__foot">
          Se te redirigirá a Microsoft para autenticarte con tu cuenta
          corporativa.
        </p>
      </div>
    </div>
  );
}
